import React from "react";
import { createRoot } from "react-dom/client";
import { Helmet } from "react-helmet";

import { AggregateOfferSchema } from "./AggregateOfferSchema";
import { BreadcrumbListSchema } from "./BreadcrumbListSchema";
import { FAQSchema } from "./FAQSchema";
import { LocalBusinessSchema } from "./LocalBusinessSchema/index";
import { makeCanonicalUrl } from "./makeCanonicalUrl";
import { OrganizationSchema } from "./OrganizationSchema";
import { ProductSchema } from "./ProductSchema";
import { WebSiteSchema } from "./WebSiteSchema";

import { isAppletPicker, isDevelopment } from "~/env";

const Applet: React.FC = () => {
  const [canonicalURL, setCanonicalURL] = React.useState<string | null>(null);

  React.useEffect(() => {
    const existingCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    
    const computedCanonicalURL = 
      window.location.origin + 
      makeCanonicalUrl(new URL(window.location.href));
    
    if (existingCanonical?.href !== computedCanonicalURL) {
      existingCanonical?.remove();
      setCanonicalURL(computedCanonicalURL);
    }
  }, []);

  if (
    !isDevelopment &&
    ![
      "www.equipmentshare.com",
      "equipmentshare-us.webflow.io",
      "equipmentshare-us-7fcd6ee2fbc58ac5b15ef.webflow.io",
      "dev-www.equipmentshare.com", 
    ].includes(window.location.hostname)
  ) {
    return null;
  }

  return (
    <React.Fragment>
      {canonicalURL && (
        <Helmet>
          <link
            rel="canonical"
            href={canonicalURL}
          />
        </Helmet>
      )}
      {/* <PressSchema />  Currently handled in Webflow*/}
      <WebSiteSchema />
      <OrganizationSchema />
      <BreadcrumbListSchema />
      {/* <ArticleSchema /> Currently handled in Webflow*/}
      {/* JobPostings are handled by JobPosting applet */}
      <FAQSchema />
      <AggregateOfferSchema />
      <ProductSchema />
      <LocalBusinessSchema />
    </React.Fragment>
  );
};

export const mount = async (el: HTMLDivElement) => {
  if (isDevelopment || isAppletPicker) {
    const fixtures = await import("./fixtures");

    const elBreadcrumbs = document.createElement("div");
    elBreadcrumbs.innerHTML = fixtures.BREADCRUMBS;
    document.body.appendChild(elBreadcrumbs);
  }

  const root = createRoot(el);
  root.render(<Applet />);
};
